<template>
  <div class="categories-wrapper machines-categories">

    <market-selected v-if="marketFilter" :market="marketFilter"></market-selected>
    <market-filter v-else ></market-filter>

    <h2 class="categories-wrapper-title " :class="{'brand-color':!isPhone}">{{ $t('categories') }}</h2>
    <div class="categories-list">
      <div
          class="category-item"
          :class="{'current is-color-red': selectedCategory && category.code === selectedCategory.code}"
          v-for="category in categories"
          v-if="activeCategories.indexOf(category.code)>-1 || activeCategories.length===0"
          :key="category.code"
          :data-tracking="`machine_search__button__${category.code}`"
          @click="$store.commit('searchMachines/setCategory', category)"
      >
        <div class="category-item-thumbnail">
          <img
              v-if="categoryPicture(category)"
              :src="categoryPicture(category)"
              alt=""
              class="picture"
          >
        </div>
        <div class="category-item-title">{{ category.label }}</div>
        <i class="fa fa-arrow-right"></i>
      </div>

      <div
          class="category-item"
          :class="{'current is-color-red': selectedCategory.code === 'best-seller'}"
          @click="$store.commit('searchMachines/setCategory', {'code':'best-seller','label': $t('best_sellers') })"
          v-if="activeCategories.indexOf('best-seller')>-1 || activeCategories.length===0"
      >
        <div class="category-item-thumbnail">
          <img
             :src="require('@/assets/img/best-seller.png')"
              alt=""
              class="picture"
          >
        </div>
        <div class="category-item-title">{{ $t('best_seller') }}</div>
        <i class="fa fa-arrow-right"></i>
      </div>

      <div
          class="category-item"
          v-show="false"
          :class="{'current is-color-red': selectedCategory.code === 'low-emission'}"
          @click="$store.commit('searchMachines/setCategory', {'code':'low-emission','label': $t('low_emissions') })"
          v-if="activeCategories.indexOf('low-emission')>-1 || activeCategories.length===0"
      >
        <div class="category-item-thumbnail">
          <img
             :src="require('@/assets/img/best-seller.png')"
              alt=""
              class="picture"
          >
        </div>
        <div class="category-item-title">{{ $t('low_emissions') }}</div>
        <i class="fa fa-arrow-right"></i>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import MarketSelected from "@/components/ResearchBlock/machines/MarketSelected";
import MarketFilter from "@/components/ResearchBlock/machines/MarketFilter";

export default {
  name: "ProductCategoryList",
  components: {
    MarketSelected,
    MarketFilter
  },
  computed: {
    ...mapState({
      categories: state => state.settings.asyncCategories,
      selectedCategory: state => state.searchMachines.category,
      marketFilter: state => state.searchMachines.marketFilter,
      isPhone: state => state.settings.isPhone,
      results: state => state.searchMachines.results,
      activeCategories: state => state.searchMachines.activeCategories,
    }),
  },
  methods : {
    categoryPicture(category) {
      try {
        return require(`@/assets/img/categories-machines/main/${category.code}.jpg`)
      } catch (e) {
        return null
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .machines-categories {

    @media #{$mq_phone_min} {
      max-height: calc(100vh - 120px);
      overflow-y: scroll;
    }

    /* width */
    &::-webkit-scrollbar {
       width: 5px;
       height: 5px;
     }

    /* Track */
    &::-webkit-scrollbar-track {
       background: #F1F1F1;
     }

    /* Handle */
    &::-webkit-scrollbar-thumb {
       border-radius: 5px;
       background: #888;
     }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
       background: #C1C1C1;
    }
  }
</style>